import React, { Component } from 'react';
import {firestore, functions} from './../../firebase-config';
import Cabecalho from './../../componentes/Cabecalho';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import 'moment-timezone';
import ReactTable from "react-table";
import { gerarStringMd5 } from '../../services/OtherServices';
import 'react-table/react-table.css';
import { asaas_account_id, asaas_valor_cobranca } from './../../config/config_api';

class RevendaListar extends Component {

    constructor (props){
        super(props);

        this.state = {
            revendas: [],
            countRevendas: 0,
            usuario: JSON.parse(window.localStorage.getItem("usuarioLogado")),
            string_md5_solicitacoes: gerarStringMd5('incluir_revenda'),
            string_md5_site: gerarStringMd5('solicitacoes'),
            usuarioLogado: JSON.parse(window.localStorage.getItem("usuarioLogado")),
            estaGerandoCobranca: false,
        }
        this.mounted = false;

    }

    componentDidMount(){

        this.mounted = true;

        firestore.collection("revenda").orderBy("plano").where("plano", ">", "basico").orderBy("penome_fantasia")
        .onSnapshot(querySnapshot => {
            var items = [];
            querySnapshot.forEach(doc => {
                var document = doc.data();
                document.id  = doc.id;
                items.push(document);
            });
            if(this.mounted) {
                this.setState({
                    revendas: items,
                    countRevendas: items.length
                });
            }
        });
    }

    componentWillUnmount(){
        this.mounted = false;
    }

    gerarCobranca = async () => {
        if(window.confirm('Deseja gerar planilha de cobrança desse mês para revendas ativas?')){
            this.setState({estaGerandoCobranca: true});

            try {
                const querySnapshot = await firestore.collection("revenda").orderBy("plano").where("plano", ">", "basico").where("status_cobranca", "==", "ativo").orderBy("penome_fantasia").get();
                var items = [];
                querySnapshot.forEach(doc => {
                    var document = doc.data();
                    document.id  = doc.id;
                    var document_cobranca = {
                        revenda_id: document.id,
                        penome_fantasia: document.penome_fantasia,
                        pecpf_cnpj: document.pecpf_cnpj !== undefined ? document.pecpf_cnpj : "",
                        valor_cobranca: document.valor_cobranca !== undefined ? parseFloat(document.valor_cobranca) : (document.pevalormensalidade !== undefined ? parseFloat(document.pevalormensalidade) : 0.0),                    
                        dia_cobranca: document.dia_cobranca !== undefined ? document.dia_cobranca : (document.pedatavencimento !== undefined ? document.pedatavencimento : ""),
                        periodo_cobranca: document.periodo_cobranca !== undefined ? document.periodo_cobranca : "mensal",
                        percentual_ff_cobranca: document.percentual_ff_cobranca !== undefined ? parseFloat(document.percentual_ff_cobranca) : 0.0,
                        mes_cobranca: document.mes_cobranca !== undefined ? document.mes_cobranca : "",
                        possui_site: document.possui_site !== undefined ? document.possui_site : "nao",
                        valor_site: document.valor_site !== undefined ? parseFloat(document.valor_site) : 0.0,
                        percentual_ff_site: document.percentual_ff_site !== undefined ? parseFloat(document.percentual_ff_site) : 0.0,
                        dias_bloqueio_inadimplencia: document.dias_bloqueio_inadimplencia !== undefined ? document.dias_bloqueio_inadimplencia : 0,
                        valor_mensalidade_oferta_autos: document.valor_mensalidade_oferta_autos !== undefined ? parseFloat(document.valor_mensalidade_oferta_autos) : 0.0,
                        percentual_ff_oferta_autos: document.percentual_ff_oferta_autos !== undefined ? parseFloat(document.percentual_ff_oferta_autos) : 0.0,
                        percentual_ff_custo_cobranca: document.percentual_ff_custo_cobranca !== undefined ? parseFloat(document.percentual_ff_custo_cobranca) : 0.0,
                        valor_mensalidade_bot: document.valor_mensalidade_bot !== undefined ? parseFloat(document.valor_mensalidade_bot) : 0.0,
                        percentual_ff_bot: document.percentual_ff_bot !== undefined ? parseFloat(document.percentual_ff_bot) : 0.0,
                        email_cobranca: document.email_cobranca !== undefined ? document.email_cobranca : "",
                        whatsapp_cobranca: document.whatsapp_cobranca !== undefined ? document.whatsapp_cobranca : "",
                    }
                    var fator_multiplicador = document_cobranca.periodo_cobranca === "anual" ? 12 : 1;
                    var text_mensalidade = document_cobranca.periodo_cobranca === "anual" ? "Anuidade" : "Mensalidade";
                    var descricao_cobranca = "Cobrança " + text_mensalidade + " Intermédio";
                    var valor_ff = document_cobranca.valor_cobranca * (document_cobranca.percentual_ff_cobranca / 100) * fator_multiplicador;
                    var cliente_cobranca = {
                        customer_name: document_cobranca.penome_fantasia,
                        customer_email: document_cobranca.email_cobranca,
                        amount: (document_cobranca.valor_cobranca + document_cobranca.valor_site + document_cobranca.valor_mensalidade_oferta_autos + document_cobranca.valor_mensalidade_bot) * fator_multiplicador,
                        due_date: gerarDataComDia(document_cobranca.dia_cobranca),
                        customer_phone: somenteNumeros(document_cobranca.whatsapp_cobranca),
                        customer_document: somenteNumeros(document_cobranca.pecpf_cnpj)
                    }
                    if(document_cobranca.possui_site === "sim" && document_cobranca.valor_site > 0){
                        var valor_ff_site = (document_cobranca.percentual_ff_site > 0 ? document_cobranca.valor_site * (document_cobranca.percentual_ff_site / 100) * fator_multiplicador : 0);
                        valor_ff = valor_ff + valor_ff_site;
                        descricao_cobranca += " + Site Personalizado";
                    }
                    if(document_cobranca.valor_mensalidade_oferta_autos > 0){
                        var valor_ff_oferta_autos = (document_cobranca.percentual_ff_oferta_autos > 0 ? document_cobranca.valor_mensalidade_oferta_autos * (document_cobranca.percentual_ff_oferta_autos / 100) * fator_multiplicador : 0);
                        valor_ff = valor_ff + valor_ff_oferta_autos;
                        descricao_cobranca += " + Publicação do estoque no site Oferta Autos";
                    }
                    if(document_cobranca.valor_mensalidade_bot > 0){
                        var valor_ff_bot = (document_cobranca.percentual_ff_bot > 0 ? document_cobranca.valor_mensalidade_bot * (document_cobranca.percentual_ff_bot / 100) * fator_multiplicador : 0);
                        valor_ff = valor_ff + valor_ff_bot;
                        descricao_cobranca += " + Bot de Atendimento Automatizado";
                    }
                    if(valor_ff > 0){
                        var valor_ff_custo_cobranca = parseFloat(asaas_valor_cobranca * (document_cobranca.percentual_ff_custo_cobranca / 100));
                        cliente_cobranca.asaas_account_id = asaas_account_id;
                        cliente_cobranca.split_type_id = 1;
                        cliente_cobranca.split_value = parseFloat(valor_ff - valor_ff_custo_cobranca).toFixed(2);
                    }
                    cliente_cobranca.description = descricao_cobranca;
                    var mes_atual = moment().month() + 1;
                    if(document_cobranca.periodo_cobranca === "mensal" || (document_cobranca.periodo_cobranca === "anual" && mes_atual === parseInt(document_cobranca.mes_cobranca, 10))){
                        items.push(cliente_cobranca);
                    }
                });

                if(items.length === 0){
                    window.alert('Nenhuma cobrança encontrada para o mês atual.');
                    return;
                }

                const referencia = moment().format("YYYY-MM");
                const gerarPlanilhaCobranca = functions.httpsCallable("gerarPlanilhaCobranca");
                const resultado = await gerarPlanilhaCobranca({
                    items: items,
                    referencia: referencia
                });

                baixarArquivoBase64(
                    resultado.data.arquivoBase64,
                    resultado.data.nomeArquivo,
                    resultado.data.mimeType
                );

                if(resultado.data.emailEnviado){
                    // const protocoloEmail = resultado.data.emailMessageId;
                    // const detalhesEmail = protocoloEmail ?
                    //     '\nIdentificador Resend: ' + protocoloEmail :
                    //     '';
                    window.alert('Planilha gerada e baixada.');
                }else{
                    // const erroEmail = resultado.data.emailErro ?
                    //     '\nDetalhes: ' + resultado.data.emailErro :
                    //     '';
                    window.alert('Planilha gerada e baixada.');
                }
            } catch (error) {
                console.error("Erro ao gerar planilha de cobrança:", error);
                window.alert('Não foi possível gerar a planilha de cobrança.');
            } finally {
                if(this.mounted){
                    this.setState({estaGerandoCobranca: false});
                }
            }
        }
    }

    render(){

        if(this.state.usuarioLogado !== null && this.state.usuarioLogado.role !== 'admin'){
            return <Redirect to='/acesso-negado' />
        }

        const columns = [     
            {
                id: 'status', 
                Header: '',
                accessor: props => ( props.pestatus !== undefined && props.pestatus.length > 0 ? <div style={{ width: '15px', height: '15px', backgroundColor: props.pestatus, borderRadius: '15px' }} ></div> : "" ),
                Cell: props => props.value,
                width: 25,
            },
            {
                id: 'logo_revenda', 
                Header: 'Logo',
                accessor: props => ( props.logotipo.length > 0 ? <img src={ props.logotipo } style={{ maxWidth: '100px', maxHeight: '70px' }} ></img> : "" ),
                Cell: props => props.value,
                width: 110,
            },
            {
                id: 'manutencao', 
                Header: 'Manutenção',
                accessor: props => ( <div className="btn-group"><a className="btn btn-primary dropdown-toggle" data-toggle="dropdown" href="#">Ações<span className="caret"></span></a><ul style={{ position: "relative", minWidth: "130px" }} className="dropdown-menu"><li><Link to={ "/revenda/"+props.id+"/usuarios/listar"} >Usuários</Link></li><li><Link to={ "/revenda/"+props.id+"/veiculos/listar" } >Veículos</Link></li><li><Link to={ "/revenda/"+props.id+"/banners/listar" } >Banners</Link></li><li><Link to={ "/revenda/"+props.id+"/vendidos/listar" } >Vendidos</Link></li><li><Link to={ "/revenda/"+props.id+"/integracao" } >Integrações</Link></li><li><Link to={ "/revenda/"+props.id+"/imagem-destaque/listar" } >Img destaque</Link></li><li><Link to={ "/revenda/"+props.id+"/banner-site/listar" } >Banner site</Link></li><li><a target="_blank" href={ "https://app.intermedioveiculos.com.br/SolicitarSite/solicitarsite.php?usuario="+this.state.usuario.id+"&revenda_id="+props.id+"&revenda_nome="+props.penome_fantasia+"&string_md5_get="+this.state.string_md5_site } >Site</a></li><li><a target="_blank" href={ "https://intermedio.app/revenda/"+props.id+"/locais-anuncio" } >Loc. anúncio</a></li><li><Link to={ "/revenda/"+props.id+"/veiculos/historico" } >Histórico</Link></li><li><Link to={ "/revenda/"+props.id+"/notificacoes/listar" } >Notificações</Link></li><li><a target="_blank" href={ "https://cadastro.intermedioveiculos.com.br/?revenda="+props.penome_fantasia+"&responsavel="+props.perazao_social_nome+"&telefone="+props.petelefone1+"&email="+props.peemail+"&idRevenda="+props.id+"&idNotificacao=idNotificacao" } >Atualizar dados</a></li><li><a href={ "https://app.intermedioveiculos.com.br/MateriaisPainel/materiaispainel.php?usuario="+this.state.usuario.id+"&string_md5="+this.state.string_md5_solicitacoes+"&revenda_id="+props.id+"&revenda_nome="+props.penome_fantasia }>Solicitações</a></li><li><Link to={ "/revenda/"+props.id+"/alterar" } >Alterar</Link></li><li><Link to={ "/revenda/"+props.id+"/excluir" } >Excluir</Link></li></ul></div> ),
                width: 150,
            },
            {
                id: 'cobranca', 
                Header: '',
                accessor: props => ( props.status_cobranca !== undefined && props.status_cobranca.length > 0 ? <div style={{ width: '15px', height: '15px', backgroundColor: props.status_cobranca == 'ativo' ? 'green' : props.status_cobranca == 'teste' ? 'yellow' : 'red', borderRadius: '15px' }} ></div> : "" ),
                Cell: props => props.value,
                width: 25,
            },
            {
                id: 'nome_fantasia', 
                Header: 'Nome da loja',
                accessor: props => props.penome_fantasia,
                Cell: props => props.value,
                width: 200,
            },
            {
                id: 'valor_mensalidade', 
                Header: 'Valor',
                accessor: props => ( props.valor_cobranca !== undefined ? parseFloat(props.valor_cobranca) : (props.pevalormensalidade !== undefined ? parseFloat(props.pevalormensalidade) : 0.0) ),
                Cell: props => formatMoney(props.value),                
                width: 100,
            },
            {
                id: 'dia_vencimento', 
                Header: 'Venc.',
                accessor: props => ( props.dia_cobranca !== undefined ? <span>{ props.dia_cobranca }</span> : (props.pedatavencimento !== undefined ? <span>{ props.pedatavencimento }</span> : "") ),
                Cell: props => props.value,
                width: 50,
            },
            {
                id: 'obs_administrativas', 
                Header: 'Observações',
                accessor: props => ( props.peobsadm !== undefined  ? <span>{ props.peobsadm }</span> : "" ),
                Cell: props => props.value,
                width: 200,
            },
            {
                id: 'cpf_cnpj', 
                Header: 'CNPJ',
                accessor: props => ( props.pecpf_cnpj !== undefined  ? <span>{ props.pecpf_cnpj }</span> : "" ),
                Cell: props => props.value,
                width: 150,
            },
            {
                id: 'razao_social', 
                Header: 'Responsável',
                accessor: props => props.perazao_social_nome,
                width: 200,
            },
            {
                id: 'cidade', 
                Header: 'Cidade',
                accessor: props => props.pecidade + "-" + props.peuf,
                width: 200,
            },
            {
                id: 'data_cadastro', 
                Header: 'Data cadastro',
                accessor: "created_at",
                Cell: props => ( props.value != null ? moment(props.value.seconds * 1000).locale('pt-BR').format("DD/MM/YYYY") : "" ),
                width: 100,
            },
            {
                id: 'dias_ativo', 
                Header: 'Dias ativo',
                accessor: props => ( props.created_at != null ? moment().diff(moment(props.created_at.seconds * 1000).locale('pt-BR').format("YYYY-MM-DD"), 'days') : "" ),
                width: 100,
            },
            {
                id: 'telefone', 
                Header: 'Telefone',
                accessor: props => props.petelefone1,
                width: 200,
            },
            {
                id: 'email', 
                Header: 'E-mail',
                accessor: props => props.peemail,
                width: 200,
            },
            {
                id: 'site', 
                Header: 'Site',
                accessor: props => props.pehomepage,
                width: 200,
            }
        ];

        return (
            <div>
                <Cabecalho />
                <div id="page-wrapper">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="page-header">Revendas</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    Lista de Revendas - { this.state.countRevendas } revendas
                                </div>
                                <div className="panel-body">
                                <button
                                    type="button"
                                    onClick={() => this.gerarCobranca()}
                                    className="btn btn-success"
                                    disabled={this.state.estaGerandoCobranca}
                                >
                                    {this.state.estaGerandoCobranca ? "Gerando cobrança..." : "Gerar Cobrança"}
                                </button><br/><br/>
                                <ReactTable
                                    data={this.state.revendas}
                                    columns={columns}
                                    showPagination={false}
                                    minRows={ this.state.countRevendas }
                                    defaultPageSize={ 0 }
                                    pageSize={ this.state.countRevendas }
                                    showPageSizeOptions={false}
                                    className={ "-highlight table-revendas" }
                                />
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
            
        )
    }

}

function baixarArquivoBase64(conteudoBase64, nomeArquivo, mimeType) {
    const conteudoBinario = window.atob(conteudoBase64);
    const bytes = new Uint8Array(conteudoBinario.length);

    for(let indice = 0; indice < conteudoBinario.length; indice++){
        bytes[indice] = conteudoBinario.charCodeAt(indice);
    }

    const arquivo = new Blob([bytes], {type: mimeType});
    const url = window.URL.createObjectURL(arquivo);
    const link = document.createElement("a");
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

function somenteNumeros(valor) {
    return valor.replace(/\D/g, '');
}

function gerarDataComDia(dia) {
    const hoje = new Date();

    const diaAtual = hoje.getDate();
    const diaVencimento = dia >= diaAtual ? dia : diaAtual;
    const ano = hoje.getFullYear();
    const mes = hoje.getMonth(); // janeiro = 0, fevereiro = 1...

    const data = new Date(ano, mes, diaVencimento);

    const diaFormatado = String(data.getDate()).padStart(2, '0');
    const mesFormatado = String(data.getMonth() + 1).padStart(2, '0');
    const anoFormatado = data.getFullYear();

    return `${diaFormatado}/${mesFormatado}/${anoFormatado}`;
};

function formatMoney(value) {

    var places = 2;
    var symbol = "R$ ";
    var thousand = ".";
    var decimal = ",";

	places = !isNaN(places = Math.abs(places)) ? places : 2;
	symbol = symbol !== undefined ? symbol : "$";
	thousand = thousand || ",";
	decimal = decimal || ".";
	var number = value, 
	    negative = number < 0 ? "-" : "",
	    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
	    j = (j = i.length) > 3 ? j % 3 : 0;
	return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
};

export default RevendaListar
